export default {
    disclaimer: {
        label_default: "我承认并同意，我订购/收到的物品是 O-I 的财产，用于 O-I 的工作相关活动，因此，O-I 保留要求我在离开 O-I 时（或 O-I 要求时更早）归还该财产的权利。",
        label_type_1: "我确认已准确、真诚地完成了居家办公自我评估，并且我将把从O-I处获得或通过Gear订购的任何设备或家具用于我在O-I的工作。我承认并同意，我订购/收到的物品是O-I的财产，用于O-I的工作相关活动，因此，O-I保留在我离开O-I时（或在O-I要求的情况下提前）要求归还该财产的权利。",
        errors: {
            required: "请接受使用条款"
        }
    },
    cost_center: {
        label: "成本中心代码",
        placeholder: "成本中心代码",
        cost_center_not_found: "未显示的成本中心最多可能需要 24 小时才能显示。如果您看不到相应的成本中心，请联系全球服务台。",
        errors: {
            regex: "无效的成本中心代码"
        }
    },
    company_code: {
        label: "公司代码"
    },
    cost_center_name: {
        label: "成本中心名称"
    },
    order_note: {
        label: "订单备注",
        placeholder: "（可选）提交给经理审批",
    },
    send_emails_to_oobo_orderer: {
        "OOBO": "请告知我此订单的最新进展"
    },
    "dell_banner":{
        label: "由于戴尔系统升级，2026年8月1日至8月14日期间提交的戴尔订单可能会出现严重的处理延迟。在此期间，订单交付时间可能会延长，敬请谅解。"
    }
}